"use client";

import React from "react";
import { Eye, Users, Phone, ChartBar, Target, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const painPoints = [{
  icon: Target,
  text: "Curriculums tailored to your specific operational workflows"
}, {
  icon: Users,
  text: "Role-based training modules for diverse team structures"
}, {
  icon: Zap,
  text: "Integration of BPO-specific tools and software platforms"
}, {
  icon: ChartBar,
  text: "Measurable skill benchmarks aligned with your KPIs"
}, {
  icon: Eye,
  text: "Real-time progress tracking for management oversight"
}];
export default function StopLosingCustomersSolution() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="259449" id="customized-learning-paths" className="bg-background text-foreground py-16 md:py-24 overflow-hidden" ref={sectionRef}>
      <div className="page-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div className={`relative transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            {}
            <div className="absolute -inset-4 bg-secondary/10 blur-3xl -z-10"></div>
            
            <div className="relative rounded-lg overflow-hidden border border-border/50 shadow-xl bg-card/40 backdrop-blur-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673581/img/skillup_learning_pathway.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673581/img/skillup_learning_pathway.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1673581/img/skillup_learning_pathway.png-wvc-sizes" alt="Visual representation of a customized learning pathway for BPO teams" className="w-full h-auto object-cover aspect-[4/3] md:aspect-square lg:aspect-[4/3]" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-secondary/20 to-transparent mix-blend-multiply pointer-events-none"></div>
            </div>
          </div>

          {}
          <div className={`flex flex-col transition-all duration-1000 delay-200 transform ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <h2 className="text-4xl md:text-5xl font-bold font-default mb-10 tracking-tighter text-foreground">
              Bespoke <span className="text-secondary">Training</span>
            </h2>

            <ul className="space-y-6 mb-10">
              {painPoints.map((point, i) => {
              const Icon = point.icon;
              return <li key={i} data-index={i} className="flex items-center gap-4 group">
                    <div className="flex items-center justify-center size-12 rounded-lg border border-secondary/20 bg-secondary/5 shrink-0 transition-colors group-hover:bg-secondary/10 group-hover:border-secondary/30">
                      <Icon className="size-5 text-secondary" />
                    </div>
                    <p className="text-muted-foreground font-default text-base md:text-lg leading-snug">
                      {point.text}
                    </p>
                  </li>;
            })}
            </ul>

            {}
            <div className="flex items-start sm:items-center gap-4 p-5 rounded-lg border border-secondary/30 bg-secondary/10 shadow-md">
              <div className="flex items-center justify-center size-8 rounded-md bg-secondary/20 shrink-0 mt-0.5 sm:mt-0">
                <Zap className="size-4 text-secondary" fill="currentColor" />
              </div>
              <p className="text-sm md:text-base font-medium font-default text-foreground leading-tight">
                We build the bridge between your current talent and future BPO excellence
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </section>;
}